import { render } from "./ScrollZoomAnimation.vue?vue&type=template&id=1655ab16&scoped=true"
import script from "./ScrollZoomAnimation.vue?vue&type=script&lang=js"
export * from "./ScrollZoomAnimation.vue?vue&type=script&lang=js"

import "./ScrollZoomAnimation.vue?vue&type=style&index=0&id=1655ab16&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1655ab16"]])

export default __exports__